import { fabric } from "fabric";
import { ObjectSuperTypesEnum } from "../../../enums";

export interface SeatCategory {
  key: number, 
  name: string, 
  color: string
}

export type FabricSeatGroup = fabric.Group & {
  id?: string;
  superType?: ObjectSuperTypesEnum.Seat;
  seatsQuantity?: number | null;
  maxSeatsQuantity?: number | null;
  rowSize?: number | null;
  seatsSpacing?: number;
  seatsCurve?: number;
  distanceBetweenX?: number;
  distanceBetweenY?: number;
  category?: SeatCategory;
  label?: string;
  displayedLabel?: string;
  restrictedView?: boolean;
  companion?: boolean;
  accesible?: boolean;
  value?: string;
  side: string;
  rowLabel?: string;
  tableLabel?: string;
  sectionLabel?: string;
};

export interface CreateSeatGroupParams {
  left: number;
  top: number;
  editable?: boolean;
  id?: string;
  category?: SeatCategory;
  label?: string;
  displayedLabel?: string;
  restrictedView?: boolean;
  companion?: boolean;
  accesible?: boolean;
  value?: string;
  seatsSpacing?: number;
  seatsCurve?: number;
  distanceBetweenX?: number;
  distanceBetweenY?: number;
  seatsQuantity?: number | null;
  maxSeatsQuantity?: number | null;
  rowSize?: number | null;
  rowLabel?: string;
  tableLabel?: string;
  sectionLabel?: string;
}

export class SeatGroupFactory {
  static create({
    left,
    top,
    editable = true,
    id,
    category = { key: 0, name: "", color: "" },
    label = "",
    displayedLabel = "",
    restrictedView = false,
    companion = false,
    accesible = false,
    value = "",
    seatsSpacing = 0,
    seatsCurve = 0,
    distanceBetweenX = 0,
    distanceBetweenY = 0,
    seatsQuantity = null,
    maxSeatsQuantity = null,
    rowSize = null,
    rowLabel = "",
    tableLabel = "",
    sectionLabel = ""
  }: CreateSeatGroupParams): FabricSeatGroup {
    const seatGroup = new fabric.Group([], {
      left,
      top,
      originX: "left",
      originY: "top",
      hasBorders: editable,
      selectable: editable,
      type: "group",
      subTargetCheck: true,
    }) as FabricSeatGroup;

    seatGroup.set({
      id,
      superType: ObjectSuperTypesEnum.Seat,
      seatsQuantity,
      maxSeatsQuantity,
      rowSize,
      seatsSpacing,
      seatsCurve,
      distanceBetweenX,
      distanceBetweenY,
      category,
      label,
      displayedLabel,
      restrictedView,
      companion,
      accesible,
      value,
      tableLabel,
      rowLabel,
      sectionLabel
    });

    seatGroup.setControlsVisibility({
      tl: false,
      mt: false,
      tr: false,
      ml: false,
      mr: false,
      bl: false,
      mb: false,
      br: false,
      mtr: false,
    });

    return seatGroup;
  }
}